import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Vehicle } from 'src/app/vehicles/model/vehicle';
import { VehiclesService } from 'src/app/vehicles/service/vehicles.service';

@Component({
  selector: 'app-stp-vehicles-selector',
  templateUrl: './stp-vehicles-selector.component.html',
  styleUrls: ['./stp-vehicles-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StpVehiclesSelectorComponent),
      multi: true
    }
  ]
})
export class StpVehiclesSelectorComponent implements OnInit {
  @Input() type: 'id' | 'sideNumber' = 'id';
  @Input() lines: number = 3;

  availableVehicles: AvaliableVehicle[] = [];
  selectedVehicles: AvaliableVehicle[] = [];
  value: string[] | number[] | null = null;
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private vehicleService: VehiclesService) { }

  ngOnInit(): void {
    this.vehicleService.getVehicles()
      .pipe(
        map(vehs => vehs.map(v => new AvaliableVehicle(v.sideNumber, this.getOptionValue(v))))
      )
      .subscribe(vehicles => {
        this.availableVehicles = vehicles;
        this.syncSelectedFromValue();
      });
  }

  getOptionValue(item: Vehicle): any {
    return this.type ? item[this.type] : item;
  }

  get chipsContainerHeight(): string {
    return `${32 * this.lines}px`;
  }

  onMultiSelectChange(): void {
    this.emitChange();
  }

  removeVehicle(vehicle: AvaliableVehicle): void {
    this.selectedVehicles = this.selectedVehicles.filter(v => v.value !== vehicle.value);
    this.emitChange();
  }

  clearSelection(): void {
    this.selectedVehicles = [];
    this.emitChange();
  }

  // ControlValueAccessor

  writeValue(value: string[] | number[] | null): void {
    this.value = value;
    this.syncSelectedFromValue();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Helpers

  private syncSelectedFromValue(): void {
    if (!this.availableVehicles.length) return;
    const values = this.value?.map(v => String(v)) ?? [];
    this.selectedVehicles = this.availableVehicles.filter(v => values.includes(String(v.value)));
  }

  private emitChange(): void {
    const vals = this.selectedVehicles.length
      ? this.selectedVehicles.map(v => v.value) as string[] | number[]
      : null;
    this.value = vals;
    this.onChange(vals);
  }
}

class AvaliableVehicle {
  constructor(
    public readonly displayValue: string,
    public readonly value: number | string,
  ) { }
}
